import { render, staticRenderFns } from "./ApplicationNewPage.vue?vue&type=template&id=51aeb462&lang=pug&"
import script from "./ApplicationNewPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports